import request from "@/axios";
/** 分页查询媒资方管理接口 */
export const getList = params => {
  return request({
    url: `/lebo-vod/vod/partner/page`,
    method: "get",
    params: params
  });
};
/** 新增媒资方管理接口 */
export const add = data => {
  return request({
    url: `/lebo-vod/vod/partner/save`,
    method: "post",
    data: data
  });
};
/** 编辑媒资方管理接口 */
export const edit = data => {
  return request({
    url: `/lebo-vod/vod/partner/update`,
    method: "post",
    data: data
  });
};
/** 删除媒资方管理接口 */
export const del = id => {
  return request({
    url: `/lebo-vod/vod/partner/delById`,
    method: "get",
    params: { id }
  });
};
